import { all } from "redux-saga/effects";

import {
  watchFilterDateSet,
  watchRequestSetFilterOpen,
} from "../services/booking-filter/filterSaga";
import { watchCreateForm } from "../services/create/createFormSaga";
import { watchFrontendOutOfDate } from "../services/frontend-out-of-date/frontendOutOfDateSaga";
import { watchGrid } from "../services/grid/gridSaga";
import { watchIntermodalCreateFormSaga } from "../services/intermodal/sagas/watchIntermodalCreateFormSaga";
import { watchIntermodalGridStatusSaga } from "../services/intermodal/sagas/watchIntermodalGridStatusSaga";
import { watchPageSettingsSaga } from "../services/page-settings/pageSettingsSaga";
import { watchSwitchResultSaga } from "../services/switch/switchSaga";
import { watchTourSaga } from "../services/tour/tourSagas";
import { watchUpdateForm } from "../services/update-form/updateFormSaga";
import { watchUrgentMessageSaga } from "../services/urgent-message/urgentMessageSaga";

export function* rootSaga() {
  yield all([
    watchCreateForm(),
    watchFilterDateSet(),
    watchFrontendOutOfDate(),
    watchGrid(),
    watchIntermodalGridStatusSaga(),
    watchIntermodalCreateFormSaga(),
    watchPageSettingsSaga(),
    watchRequestSetFilterOpen(),
    watchSwitchResultSaga(),
    watchTourSaga(),
    watchUpdateForm(),
    watchUrgentMessageSaga(),
  ]);
}
